"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _analytics = require("../../analytics");
var _questionnaireActions = require("../../../store/questionnaire/questionnaireActions");
var _constants = require("../../../utils/constants");
var _services = require("../../../services");
var _errorActions = require("../../../store/error/errorActions");
var _productCatalogActions = require("../../../store/productCatalog/productCatalogActions");
class AnalyticsServiceDE extends _analytics.AnalyticsService {
  constructor(config) {
    super(config);
    this.questionsAnswers = [];
  }
  startJourney() {
    console.log('Germany Journey started ....');
  }
  _getSelectionsIndex(questions, selections) {
    return questions === null || questions === void 0 ? void 0 : questions.map((question, index) => {
      if (question.type !== _constants.QUESTION_TYPE.CHOICES) return;
      const selectedChoices = selections[index] || [];
      const selectedIndexes = selectedChoices.map(choice => {
        var _question$choices;
        const choiceIndex = question === null || question === void 0 ? void 0 : (_question$choices = question.choices) === null || _question$choices === void 0 ? void 0 : _question$choices.findIndex(c => c.text === choice);
        return choiceIndex !== -1 ? choiceIndex + 1 : null;
      });
      if (selectedIndexes.length === 1) {
        return selectedIndexes[0].toString();
      }
      if (selectedIndexes.length > 1) {
        return selectedIndexes.join('-');
      }
    }).filter(Boolean).join('|');
  }
  _composeTaggingViewEvent(_ref) {
    let {
      eventName,
      currentQuestion,
      currentProduct,
      questions,
      answersSelections,
      stepIndex,
      isRecommendationAPIError
    } = _ref;
    if (eventName === 'onToolResult') {
      var _currentProduct$selec, _currentProduct$selec2, _currentProduct$produ, _currentProduct$selec3, _currentProduct$selec4;
      const availableTechnologies = currentProduct === null || currentProduct === void 0 ? void 0 : (_currentProduct$selec = currentProduct.selectedVariant) === null || _currentProduct$selec === void 0 ? void 0 : (_currentProduct$selec2 = _currentProduct$selec.mainCharacteristics) === null || _currentProduct$selec2 === void 0 ? void 0 : _currentProduct$selec2.find(el => el.id === 'TECHNOLOGY').valueText;
      return {
        site_area: 'fixnet',
        page_levels: ['privatkunden', 'verfuegbarkeit von internet-, telefon- und tv-angeboten pruefen', 'availability check', 'complete'],
        page_type: 'availability',
        form_type: 'availability',
        form_name: 'category availability check',
        form_step: ((questions === null || questions === void 0 ? void 0 : questions.length) + 1).toString(),
        form_outcome: this._getSelectionsIndex(questions, answersSelections),
        form_step_name: 'complete',
        form_status: ['end', 'success'],
        recommended_products: [currentProduct === null || currentProduct === void 0 ? void 0 : (_currentProduct$produ = currentProduct.productId) === null || _currentProduct$produ === void 0 ? void 0 : _currentProduct$produ.toUpperCase()],
        available_technologies: [availableTechnologies === null || availableTechnologies === void 0 ? void 0 : availableTechnologies.toLowerCase()],
        available_bandwidth: currentProduct === null || currentProduct === void 0 ? void 0 : (_currentProduct$selec3 = currentProduct.selectedVariant) === null || _currentProduct$selec3 === void 0 ? void 0 : (_currentProduct$selec4 = _currentProduct$selec3.mainCharacteristics) === null || _currentProduct$selec4 === void 0 ? void 0 : _currentProduct$selec4.find(el => el.id === 'BROADBAND_SPEED').valueText,
        login_status: 'not logged in',
        platform_type: 'responsive',
        line_of_customer: 'consumer'
      };
    }
    if (eventName === 'onError' || eventName === 'onValidationError') {
      const errorEvent = {
        error_action: 'displayed',
        error_type: eventName === 'onValidationError' ? 'validation' : 'technical',
        error_message: eventName === 'onValidationError' ? _services.locale.localeString('PageErrorMessage.ValidationErrorMessageHeading') : _services.locale.localeString('PageErrorMessage.ErrorMessageHeading')
      };

      // error on last step, recommendation page
      if ((questions === null || questions === void 0 ? void 0 : questions.length) + 1 === stepIndex && isRecommendationAPIError) {
        return {
          taggingType: 'view',
          form_name: 'category availability check',
          form_status: ['end', 'failure'],
          form_step: '5',
          form_step_name: 'complete',
          form_type: 'availability',
          page_levels: ['privatkunden', 'verfuegbarkeit von internet-, telefon- und tv-angeboten pruefen', 'availability check', 'complete'],
          page_type: 'availability',
          site_area: 'fixnet',
          login_status: 'not logged in',
          platform_type: 'responsive',
          line_of_customer: 'consumer',
          ...errorEvent
        };
      }
      return errorEvent;
    }
    return currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.taggingMetadata;
  }
  composeTaggingEvents(_ref2) {
    let {
      eventName,
      currentQuestion,
      currentProduct,
      questions,
      answersSelections,
      stepIndex,
      isRecommendationAPIError,
      isAddressAPIError
    } = _ref2;
    const eventViewTag = this._composeTaggingViewEvent({
      eventName,
      currentQuestion,
      currentProduct,
      questions,
      answersSelections,
      stepIndex,
      isRecommendationAPIError
    });
    return {
      onToolView: {
        taggingId: `${stepIndex}`,
        taggingType: 'view',
        ...eventViewTag
      },
      onToolResult: {
        taggingId: `${stepIndex}`,
        taggingType: 'view',
        ...eventViewTag
      },
      onError: {
        taggingId: `${stepIndex}`,
        taggingType: 'error',
        ...eventViewTag
      },
      onValidationError: isAddressAPIError && eventName === 'onValidationError' && {
        taggingId: `${stepIndex}`,
        taggingType: 'error',
        ...eventViewTag
      }
    };
  }
  getEventsName() {
    return {
      [_questionnaireActions.VIEW_QUESTION]: {
        eventName: 'onToolView'
      },
      [_errorActions.API_CALL_ERROR]: {
        eventName: 'onError'
      },
      [_productCatalogActions.FETCH_BROADBAND_ADDRESSES_ERROR]: {
        eventName: 'onValidationError'
      }
    };
  }
}
var _default = AnalyticsServiceDE;
exports.default = _default;